import React from 'react';
import Layout from '../components/Layout';

const FranchisePage = () => {
    return (
        <Layout>
            {/* Hero Section */}
            <section
                id="franchise-hero"
                className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
                style={{ backgroundImage: 'url("/franchise.jpg")' }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <div className="relative text-center text-white px-6">
                    <h1 className="text-6xl font-bold mb-4">Franchise with KAR</h1>
                    <p className="text-lg md:text-2xl mb-6">
                        Join the KAR family and bring exceptional car rental services to your city. Drive success
                        with our proven model, premium fleet, and outstanding customer service.
                    </p>
                    <a 
                        href="https://drive.google.com/file/d/1W55isp2249La3L8R4vI6rn5fu-PCEhGy/view?usp=sharing" 
                        target="_blank" 
                        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-full text-lg"
                        rel="noopener noreferrer"
                        download
                    >
                        Learn More
                    </a>

                </div>
            </section>

            {/* Franchise Details */}
            <section id="franchise-details" className="py-6">
                <div className="container mx-auto px-4 max-w-6xl">
                    <h2 className="text-4xl font-bold text-center mb-12">Franchise Opportunities</h2>

                    {/* Join the Network */}
                    <div className="mb-12">
                        <h3 className="text-3xl font-semibold mb-4">Join the KAR Network</h3>
                        <p className="text-lg leading-relaxed">
                            At KAR, we’re redefining the car rental experience with a focus on seamless service,
                            innovation, and customer satisfaction. Now, you can be part of this growing success
                            by owning and operating your own KAR franchise. As an owner-operator, you’ll have
                            the opportunity to build a thriving business in your community while benefiting from
                            the strength and support of the KAR brand.
                        </p>
                    </div>

                    {/* Why Choose KAR */}
                    <div className="mb-12">
                        <h3 className="text-3xl font-semibold mb-4">Why Choose KAR?</h3>
                        <ul className="list-inside list-disc text-lg space-y-4">
                            <li><b>Established Brand:</b> Leverage the recognition and trust KAR has built in the car rental industry.</li>
                            <li><b>Proven Business Model:</b> Access a framework that has been tested and refined for success.</li>
                            <li><b>Comprehensive Support:</b> From training and marketing to ongoing operational guidance, we are with you every step of the way.</li>
                            <li><b>Dedicated Area Focus:</b> Build your franchise in a defined market area with full support to maximize your local success.</li>
                            <li><b>Owner-Operator Model:</b> Actively manage your franchise and drive profitability.</li>
                        </ul>
                    </div>

                    {/* What We Offer */}
                    <div className="mb-12">
                        <h3 className="text-3xl font-semibold mb-4">What We Offer</h3>
                        <ul className="list-inside list-disc text-lg space-y-4">
                            <li>A turnkey business opportunity with tools, resources, and training for success.</li>
                            <li>Assistance with fleet selection, operations, and customer service strategies.</li>
                            <li>Marketing materials and a digital platform tailored to your location.</li>
                            <li>Hands-on involvement to grow your franchise and impact its success directly.</li>
                        </ul>
                    </div>

                    {/* What We’re Looking For */}
                    <div className="mb-12">
                        <h3 className="text-3xl font-semibold mb-4">What We’re Looking For</h3>
                        <ul className="list-inside list-disc text-lg space-y-4">
                            <li>Passionate individuals committed to delivering exceptional service.</li>
                            <li>Entrepreneurs with a drive to succeed and a focus on customer satisfaction.</li>
                            <li>Owner-operators ready to take a hands-on approach to growing their franchise.</li>
                            <li>Partners who align with KAR’s values and vision for innovation and quality.</li>
                        </ul>
                    </div>

                    {/* Steps to Join */}
                    <div className="mb-12">
                        <h3 className="text-3xl font-semibold mb-4">Take the First Step</h3>
                        <ol className="list-inside list-decimal text-lg space-y-4">
                            <li><b>Apply Now:</b> Contact us to express your interest and learn more about available opportunities.</li>
                            <li><b>Review Our Program:</b> We’ll provide detailed information about the process, costs, and expectations.</li>
                            <li><b>Launch Your Franchise:</b> With our support, you’ll be ready to open your doors and start building your business.</li>
                        </ol>
                    </div>

                    {/* Contact Information */}
                    <div className="text-center">
                        <h3 className="text-3xl font-semibold mb-4">Contact Us for More Information</h3>
                        <p className="text-lg">
                            Ready to explore the possibilities? Reach out to our franchise team today:
                        </p>
                        <p className="text-lg font-bold mt-4">
                            <b>Email:</b> info@karrentals.ca <br />
                            <b>Phone:</b> +1 (250) 575-6041
                        </p>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default FranchisePage;
